var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var NextCircle32 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '32px' : _c, _d = _a.width, width = _d === void 0 ? '32px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 32 32", style: svgStyle },
            React.createElement("g", null,
                React.createElement("path", { d: "M16 31c8.285 0 15-6.717 15-15 0-8.283-6.715-15-15-15S1 7.717 1 16c0 8.283 6.715 15 15 15zm0-1C8.268 30 2 23.731 2 16S8.268 2 16 2s14 6.269 14 14-6.268 14-14 14z" }),
                React.createElement("path", { d: "M21.354 15.707l-4.31-3.972.677-.735 5.577 5.138-5.577 5.137-.678-.735 4.161-3.833H8.75v-1h12.604z" })))));
};
NextCircle32.displayName = 'NextCircle32';
export default NextCircle32;
//# sourceMappingURL=next-circle-32.js.map